<div class="d-flex gap-2">
    <p class="fw-bold fs-4">{{ "help.contextual_help" | translate }}</p>
</div>

<div class="bg-card shadow-md rounded p-2 mb-3">
    <form class="col-12" [formGroup]="contextualHelpForm">
        <div class="bg-card shadow-md rounded p-2 mb-3">
            <div class="row">
                <div class="col-12">
                    <adaa-form-dropdown
                        controlName="helpFormPath"
                        formControlName="helpFormPath"
                        [label]="'help.help_modal.page_name' | translate"
                        [options]="categoryOptions()"
                        [invalid]="checkInvalid('helpFormPath')"
                        [clearable]="true"
                        [setValidator]="formValidation()!"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <adaa-form-input
                        [label]="'help.help_modal.section_titleAE' | translate"
                        [setValidator]="formValidation()!"
                        [invalid]="checkInvalid('pageTitleAE')"
                        formControlName="pageTitleAE"
                        controlName="pageTitleAE"
                    ></adaa-form-input>
                </div>
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <adaa-form-input
                        [label]="'help.help_modal.section_titleEN' | translate"
                        [setValidator]="formValidation()!"
                        [invalid]="checkInvalid('pageTitleEN')"
                        formControlName="pageTitleEN"
                        controlName="pageTitleEN"
                    ></adaa-form-input>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <adaa-form-input
                        [label]="'help.help_modal.video_ae_url' | translate"
                        [setValidator]="formValidation()!"
                        [invalid]="checkInvalid('videoUrlAE')"
                        formControlName="videoUrlAE"
                        controlName="videoUrlAE"
                    ></adaa-form-input>
                </div>
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <adaa-form-input
                        [label]="'help.help_modal.video_en_url' | translate"
                        [setValidator]="formValidation()!"
                        [invalid]="checkInvalid('videoUrlEN')"
                        formControlName="videoUrlEN"
                        controlName="videoUrlEN"
                    ></adaa-form-input>
                </div>
            </div>
            <div class="row my-2">
                <div class="col-12 d-flex justify-content-center">
                    <adaa-form-checkbox
                        [label]="'help.help_modal.contextual_published' | translate"
                        [checkboxMode]="'yesNo'"
                        controlName="published"
                        formControlName="published"
                    ></adaa-form-checkbox>
                </div>
            </div>
        </div>
    </form>
</div>

<div class="p-2">
    <adaa-data-table
        #adaaDataTable
        [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.CONTEXTUAL_HELP_SUB_LIST"
        [isLocalData]="true"
        [localData]="contentsFiltered()"
        [enableViewAction]="false"
        (actionClicked)="getAction($event)"
        (addNewClicked)="addNew()"
    ></adaa-data-table>
</div>

<div class="my-2">
    <adaa-form-action-buttons
        [showSaveButton]="pageMode() !== PageMode.view"
        [saveButtonTitle]="'common.form.button.submit' | translate"
        [cancelButtonTitle]="pageMode() === PageMode.view ? ('common.form.button.close' | translate) : ('common.form.button.cancel' | translate)"
        (saveClicked)="submit()"
        (cancelClicked)="close()"
    ></adaa-form-action-buttons>
</div>

<adaa-contextual-help-content-editor #editor (content)="setContent($event)"></adaa-contextual-help-content-editor>
